/**
 * 브라우저 정보 (opensource)
 * @returns {*}
 */
export const browser = () => {
    // Opera 8.0+
    const isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

    // Firefox 1.0+
    const isFirefox = typeof InstallTrigger !== 'undefined';

    // Safari 3.0+ "[object HTMLElementConstructor]"
    const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) {
        return p.toString() === "[object SafariRemoteNotification]";
    })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

    // Internet Explorer 6-11
    const isIE = /*@cc_on!@*/false || !!document.documentMode;

    // Edge 20+
    const isEdge = !isIE && !!window.StyleMedia;

    // Chrome 1+
    const isChrome = !!window.chrome;

    // Blink engine detection
    const isBlink = (isChrome || isOpera) && !!window.CSS;

    return {
        isOpera : isOpera,
        isFirefox : isFirefox,
        isSafari : isSafari,
        isIE : isIE,
        isEdge : isEdge,
        isChrome : isChrome,
        isBlink : isBlink,
    }
};